/**
 * Unpaywall — finds free full-text versions of paywalled papers
 *
 * Declares a single web-accessible-resource, `unpaywall.html`, matched to every origin
 * with no `use_dynamic_url`. That one static entry is reachable from any page at a fixed
 * URL, and its vendor name makes a successful fetch conclusive. There is no image WAR,
 * so the HTML entry point is the only — and sufficient — signal.
 *
 * Manifest verified against version 3.99.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'iplffkdpngmdjhlpjmppncnlhomiipha';

export const unpaywall: ExtensionDefinition = {
  id: ID,
  name: 'Unpaywall',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'Exactly one static WAR (unpaywall.html) on every origin with no dynamic URL. ' +
    'Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-unpaywall-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch unpaywall.html — the extension\'s only web-accessible resource, a ' +
        'vendor-named entry point exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'unpaywall.html'),
    },
  ],
};
